/* eslint-disable no-debugger */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Downgraded, useState } from '@hookstate/core';
import { useParams, useHistory } from 'react-router-dom';
import RouteConstants from '../../../constants/routeConstants';
import AirTransport from './airTransport';
import GroundTransport from './groundTransport';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import Helper from '../../../utility/helper';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import AppConstants from '../../../constants/appConstants';
import { useEventState } from '../../../stores/eventStore';
import { FULL_PERMISSION } from '../../../constants/Constant';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';

const CreateDraftTransit = () => {
    let params = useParams();
    const history = useHistory();
    const eventState = useEventState();
    const transitType = useState(null);
    const originalBusinessTickets = useState(0);
    const originalEconomyTickets = useState(0);
    const allocatedBusinessTickets = useState(0);
    const allocatedEconomyTickets = useState(0);
    const remainingArrivalBusinessTickets = useState(0);
    const remainingDepartureBusinessTickets = useState(0);
    const remainingArrivalEconomyTickets = useState(0);
    const remainingDepartureEconomyTickets = useState(0);
    const remainingGroundTransportTicket = useState(0);
    const transitID = useState(0);
    const transitInfo = useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            
            if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'DRAFTTRANSPORTATION'
                        )
                    );
                }
            } else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)  || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION) {
            let historyState = null;
            if (
                history.location &&
                typeof history.location.state !== 'undefined' &&
                transitType.get() == null
            ) {
                // console.log("into if");
                historyState = history.location.state;
                transitType.set(historyState.transitType.toLowerCase());
            }
            if (params.transitID) {
                // console.log("params.transitID",params.transitID);
                transitID.set(params.transitID);
                // console.log("historyState.transitType",historyState?.transitType);
                if (historyState.transitType.toLowerCase() == 'air') {
                    getAirTransportInfo(params.transitID);
                } else {
                    getGroundTransportInfo(params.transitID);
                }
            } else {
                // console.log("into if else");
                transitInfo.set(null);
            }
            originalBusinessTickets.set(historyState.originalBusinessTickets)
            originalEconomyTickets.set(historyState.originalEconomyTickets)
            allocatedBusinessTickets.set(historyState.allocatedBusiness)
            allocatedEconomyTickets.set(historyState.allocatedEconomy)

            remainingArrivalBusinessTickets.set(historyState.remainingArrivalBusiness)
            remainingArrivalEconomyTickets.set(historyState.remainingArrivalEconomy)
            remainingDepartureBusinessTickets.set(historyState.remainingDepartureBusiness)
            remainingDepartureEconomyTickets.set(historyState.remainingDepartureEconomy)
            remainingGroundTransportTicket.set(historyState.remainingGroundTransportTicket)
 
            if (
                Helper.isAdminUser(userInfo) ||
                (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
            ) {
                ApiHelper.get(
                    APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                        eventInfo.eventID
                    )
                ).then((res) => {
                    if (res.data.rows) {
                        const participants = res.data.rows.filter(
                            (participant) =>
                                AppConstants.EVENT_ROLES_VALUES.indexOf(
                                    participant.roleName
                                ) == -1
                        );
                        setParticipantList(participants);
                    }
                });
            }
        }
    }, [modPermission]);

    const getAirTransportInfo = (transitID) => {
        ApiHelper.get(APIURLConstants.GET_DRAFT_AIRTRANSPORT_ROW(transitID))
            .then((res) => {
                if (res.data) transitInfo.set(res.data);
            })
            .catch((error) => {
                console.log('error : ', error);
            });
    };

    const getGroundTransportInfo = (transitID) => {
        ApiHelper.get(APIURLConstants.GET_DRAFT_GNDTRANSPORT_ROW(transitID))
            .then((res) => {
                if (res.data) transitInfo.set(res.data);
            })
            .catch((error) => {
                console.log('error : ', error);
            });
    };
// console.log("modPermission",modPermission);
    return (
        <Box
            className="otherContentBox"
            sx={{
                '& .MuiGrid-item': { p: 2 },
                '& .MuiFormControl-root': { width: '100%' },
            }}>
            {modPermission && modPermission != FULL_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <>
                    {transitType.get() ? (
                        transitType.get() === 'air' ? (
                            <AirTransport
                                transitID={transitID.get()}
                                transitInfo={transitInfo
                                    .attach(Downgraded)
                                    .get()}
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                history={history}
                                participantList={participantList}
                                modPermission={modPermission}
                                originalBusinessTickets={originalBusinessTickets.get()}
                                originalEconomyTickets={originalEconomyTickets.get()}
                                totalBusinessTickets={allocatedBusinessTickets.get()}
                                totalEconomyTickets={allocatedEconomyTickets.get()}
                                remainingArrivalBusinessTickets={remainingArrivalBusinessTickets.get()}
                                remainingArrivalEconomyTickets={remainingArrivalEconomyTickets.get()}
                                remainingDepartureBusinessTickets={remainingDepartureBusinessTickets.get()}
                                remainingDepartureEconomyTickets={remainingDepartureEconomyTickets.get()}
                                remainingGroundTransportTicket={remainingGroundTransportTicket.get()}
                            //businessTicket={businessTicket.get()}
                            //economyTicket={economyTicket.get()}
                            //noOfBusinessTicket={noOfBusinessTicket.get()}
                            //noOfEconomyTicket={noOfEconomyTicket.get()}
                            />
                        ) : (
                            <GroundTransport
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                history={history}
                                transitID={params.transitID}
                                transitInfo={transitInfo
                                    .attach(Downgraded)
                                    .get()}
                                participantList={participantList}
                                modPermission={modPermission}
                            />
                        )  
                    ): null}
                </>
            )}
            {/* </Grid> */}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: [
            RouteConstants.DRAFT_EVENT_CREATE_TRANSIT,
            RouteConstants.DRAFT_EVENT_EDIT_TRANSIT,
        ],
        component: CreateDraftTransit,
    },
    name: 'CreateDraftTransit',
};
